import {
  createButtonColumn,
  createCheckboxColumn,
  createColumn,
  createDropdownColumn,
  createEditableColumn
} from "../components/Table/Table";
import { editActions } from "../actions/editActions";
import formatDateString from "../utils/utils";
import { faultsDateUserColumn } from "./faultTableConfig";

export const faultComponentsColumns: State.Column[] = [
  createDropdownColumn(
    "Domain Group",
    (enumeration: Api.FaultComponentEnumeration) => enumeration.extraDomainGroupName,
    "enumeration.extraDomainGroupName",
    true
  ),
  createColumn(
    "Code",
    (enumeration: Api.FaultComponentEnumeration) => enumeration.enumValue,
    "enumeration.enumValue",
    true,
    80
  ),
  createColumn(
    "Enumeration",
    (enumeration: Api.FaultComponentEnumeration) => enumeration.enumName,
    "enumeration.enumName",
    true
  ),
  createColumn(
    "Min Range",
    (enumeration: Api.FaultComponentEnumeration) => enumeration.faultRangeMin,
    "enumeration.faultRangeMin",
    true, 
    100
  ),
  createColumn(
    "Max Range",
    (enumeration: Api.FaultComponentEnumeration) => enumeration.faultRangeMax,
    "enumeration.faultRangeMax",
    true, 
    100
  ),
  createColumn(
    "Comment",
    (enumeration: Api.FaultComponentEnumeration) => enumeration.comment,
    "enumeration.comment",
    true
  ),
  createColumn(
    "Name (en-US)",
    (enumeration: Api.FaultComponentEnumeration) => enumeration.name,
    "enumeration.name",
    true
  ),
  ...faultsDateUserColumn
];

// Audit columns shared across domain tables
const domainAuditColumns: State.Column[] = [
  createColumn(
    "Created By",
    (enumeration: Api.Domain) => enumeration.createdBy,
    "enumeration.createdBy",
    false
  ),
  createColumn(
    "Created Date",
    (enumeration: Api.Domain) => enumeration.createdDate,
    "enumeration.createdDate",
    false
  ),
  createColumn(
    "Modified By",
    (enumeration: Api.Domain) => enumeration.modifiedBy,
    "enumeration.modifiedBy",
    false
  ),
  createColumn(
    "Modified Date",
    (enumeration: Api.Domain) => enumeration.modifiedDate,
    "enumeration.modifiedDate",
    false
  )
];

export const grandNormsColumns: State.Column[] = [
  createColumn(
    "Code",
    (grandNorm: Api.GrandNorm) => grandNorm.code,
    "grandNorm.code",
    true,
    80
  ),
  createColumn(
    "Name",
    (grandNorm: Api.GrandNorm) => grandNorm.name,
    "grandNorm.name",
    true
  ),
  createDropdownColumn(
    "Domain Group",
    (grandNorm: Api.GrandNorm & { extraDomainGroupName?: string }) => grandNorm.extraDomainGroupName,
    "grandNorm.extraDomainGroupName",
    true
  ),
  createColumn(
    "Created By",
    (grandNorm: Api.GrandNorm) => grandNorm.createdBy,
    "grandNorm.createdBy",
    false
  ),
  createColumn(
    "Created Date",
    (grandNorm: Api.GrandNorm) => grandNorm.createdDate,
    "grandNorm.createdDate",
    false
  ),
  createColumn(
    "Modified By",
    (grandNorm: Api.GrandNorm) => grandNorm.modifiedBy,
    "grandNorm.modifiedBy",
    false
  ),
  createColumn(
    "Modified Date",
    (grandNorm: Api.GrandNorm) => grandNorm.modifiedDate,
    "grandNorm.modifiedDate",
    false
  )
];

export const domainsColumns: State.Column[] = [
  createColumn(
    "Code",
    (enumeration: Api.Domain) => enumeration.enumValue,
    "enumeration.enumValue",
    true
  ),
  createColumn(
    "Enumeration",
    (enumeration: Api.Domain) => enumeration.enumName,
    "enumeration.enumName",
    true
  ),
  createColumn(
    "Comment",
    (enumeration: Api.Domain) => enumeration.swComment,
    "enumeration.swComment",
    true
  ),
  createDropdownColumn(
    "Domain Group",
    (enumeration: Api.Domain) => enumeration.extraDomainGroupName,
    "enumeration.extraDomainGroupName",
    true
  ),
  createColumn(
    "Electrifications",
    (enumeration: Api.Domain) =>
      enumeration.electrifications
        ? enumeration.electrifications.map(e => e.enumName).join(",")
        : "",
    "enumeration.electrifications",
    true
  ),
  ...domainAuditColumns
];

export const parameterCategoriesColumns: State.Column[] = [
  createDropdownColumn(
    "Domain Group",
    (enumeration: Api.ParameterCategory) => enumeration.extraDomainGroupName,
    "enumeration.extraDomainGroupName",
    true,
    110
  ),
  createDropdownColumn(
    "Domain",
    (enumeration: Api.ParameterCategory) => enumeration.extraDomainName,
    "enumeration.extraDomainName",
    true,
    140
  ),
  createColumn(
    "Code",
    (enumeration: Api.ParameterCategory) => enumeration.enumValue,
    "enumeration.enumValue",
    true,
    80
  ),
  createColumn(
    "Enumeration",
    (enumeration: Api.ParameterCategory) => enumeration.enumName,
    "enumeration.enumName",
    true
  ),
  createColumn(
    "Name",
    (enumeration: Api.ParameterCategory) => enumeration.name,
    "enumeration.name",
    true
  ),
  createColumn(
    "Description",
    (enumeration: Api.ParameterCategory) => enumeration.description,
    "enumeration.description",
    true
  ),
  createColumn(
    "Created By",
    (enumeration: Api.ParameterCategory) => enumeration.createdBy,
    "enumeration.createdBy",
    false
  ),
  createColumn(
    "Created Date",
    (enumeration: Api.ParameterCategory) => enumeration.createdDate,
    "enumeration.createdDate",
    false
  ),
  createColumn(
    "Modified By",
    (enumeration: Api.ParameterCategory) => enumeration.modifiedBy,
    "enumeration.modifiedBy",
    false
  ),
  createColumn(
    "Modified Date",
    (enumeration: Api.ParameterCategory) => enumeration.modifiedDate,
    "enumeration.modifiedDate",
    false
  ),
  
];

export const enumerationsColumns: State.Column[] = [
  createColumn(
    "Target",
    (enumeration: Api.CommonEnumeration) => enumeration.target,
    "enumeration.target",
    true
  ),
  createColumn(
    "Name",
    (enumeration: Api.CommonEnumeration) => enumeration.name,
    "enumeration.name",
    true
  ),
  createCheckboxColumn(
    "Localized",
    (enumeration: Api.CommonEnumeration) => enumeration.isLocalized,
    "enumeration.isLocalized",
    true,
    80
  ),
  createColumn(
    "Comment",
    (enumeration: Api.CommonEnumeration) => enumeration.comment,
    "enumeration.comment",
    true
  ),
  createColumn(
    "Created By",
    (enumeration: Api.CommonEnumeration) => enumeration.createdBy,
    "enumeration.createdBy",
    true
  ),
  createColumn(
    "Created Date",
    (enumeration: Api.CommonEnumeration) => enumeration.createdDate,
    "enumeration.createdDate",
    true
  ),
  createColumn(
    "Modified By",
    (enumeration: Api.CommonEnumeration) => enumeration.modifiedBy,
    "enumeration.modifiedBy",
    true
  ),
  createColumn(
    "Modified Date",
    (enumeration: Api.CommonEnumeration) => enumeration.modifiedDate,
    "enumeration.modifiedDate",
    true
  ),
  createButtonColumn(
    "Edit",
    (enumeration: Api.CommonEnumeration) => enumeration,
    "enumeration",
    true,
    (e, row) => {
      editActions.startEditing(row.Edit as Api.CommonEnumeration);
      e.stopPropagation();
    },
    50
  )
];

export const enumerationItemsColumns: State.Column[] = [
  createColumn(
    "Value",
    (enumeration: Api.CommonEnumerationItem) => enumeration.enumValue,
    "enumeration.enumValue",
    true,
    100
  ),
  createColumn(
    "Element name",
    (enumeration: Api.CommonEnumerationItem) => enumeration.enumName,
    "enumeration.enumName",
    true,
    300
  ),
  createColumn(
    "Comment",
    (enumeration: Api.CommonEnumeration) => enumeration.comment,
    "enumeration.comment",
    true
  ),
  createColumn(
    "Created By",
    (enumeration: Api.CommonEnumerationItem) => enumeration.createdBy,
    "enumeration.createdBy",
    true
  ),
  createColumn(
    "Created Date",
    (enumeration: Api.CommonEnumerationItem) => enumeration.createdDate,
    "enumeration.createdDate",
    true
  ),
  createColumn(
    "Modified By",
    (enumeration: Api.CommonEnumerationItem) => enumeration.modifiedBy,
    "enumeration.modifiedBy",
    true
  ),
  createColumn(
    "Modified Date",
    (enumeration: Api.CommonEnumerationItem) => enumeration.modifiedDate,
    "enumeration.modifiedDate",
    true
  )
];

export const publishedFilesLocalesColumns: State.Column[] = [
  createColumn(
    "Locale",
    (localeFileSet: Api.PublishedFilesInLocale) => localeFileSet.locale,
    "localeFileSet.locale",
    true,
    undefined,
    undefined,
    true
  ),
  createButtonColumn(
    "Edit",
    (localeFileSet: Api.PublishedFilesInLocale) => localeFileSet.locale,
    "localeFileSet.locale",
    true,
    e => {
      // editActions.startEditing(row.Edit as Api.CommonEnumeration);
      e.stopPropagation();
    },
    100,
    undefined,
    undefined,
    true
  )
];

export const publishedFilesColumns: State.Column[] = [
  createColumn(
    "Name",
    (fileInLocale: Api.PublishedFileInfo) => fileInLocale.name,
    "fileInLocale.name",
    true,
    undefined,
    undefined,
    true,
    "#0071b9" // $blue900
  ),
  createColumn(
    "Modified",
    (fileInLocale: Api.PublishedFileInfo) =>
      formatDateString(new Date(fileInLocale.modified).toISOString()),
    "fileInLocale.modified",
    true,
    undefined,
    undefined,
    true,
    undefined,
    "right"
  )
];

export const translationLogColumns: State.Column[] = [
  // Id, Name, Domain group, Item type, Domain, Translation status
  createEditableColumn(
    "Translation date",
    (translationLogItem: Api.TranslationLogItem) => translationLogItem.translationDate,
    "translationLogItem.translationDate",
    true,
    200,
    undefined,
    "text"
  ),
  createEditableColumn(
    "Translator",
    (translationLogItem: Api.TranslationLogItem) => translationLogItem.translator,
    "translationLogItem.translator",
    true,
    200,
    undefined,
    "text"
  ),
  createEditableColumn(
    "Language",
    (translationLogItem: Api.TranslationLogItem) => translationLogItem.language,
    "translationLogItem.language",
    true,
    200,
    undefined,
    "text"
  ),
  createEditableColumn(
    "Translation status",
    (translationLogItem: Api.TranslationLogItem) => translationLogItem.translationStatus,
    "translationLogItem.translationStatus",
    true,
    200,
    undefined,
    "text"
  ),
  createEditableColumn(
    "Translated content",
    (translationLogItem: Api.TranslationLogItem) => translationLogItem.translatedContent,
    "translationLogItem.translatedContent",
    true,
    200,
    undefined,
    "text"
  )
];

export const languagesColumns: State.Column[] = [
  createColumn("Locale", (locale: Api.Locale) => locale.locale, "locale.locale", true),
  createColumn(
    "Friendly Name",
    (locale: Api.Locale) => locale.friendlyName,
    "locale.friendlyName",
    true
  ),
  createColumn("Comment", (locale: Api.Locale) => locale.comment, "locale.comment", true),
  createCheckboxColumn(
    "Disabled",
    (locale: Api.Locale) => locale.disabled,
    "locale.disabled",
    true,
    80
  )
];
